/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import PropTypes from 'prop-types';
export const playerEventsTypeSet = {
  'onControlsHidden': PropTypes.func,
  'onControlsShown': PropTypes.func
};
export const rendererEventsTypeSet = {
  'onCanPlay': PropTypes.func,
  'onEnded': PropTypes.func,
  'onError': PropTypes.func,
  'onLoadedData': PropTypes.func,
  'onLoadedMetadata': PropTypes.func,
  'onPause': PropTypes.func,
  'onPlay': PropTypes.func,
  'onPlaying': PropTypes.func,
  'onProgress': PropTypes.func,
  'onRateChange': PropTypes.func,
  'onSeeked': PropTypes.func,
  'onSeeking': PropTypes.func,
  'onStalled': PropTypes.func,
  'onTimeUpdate': PropTypes.func,
  'onVolumeChange': PropTypes.func,
  'onWaiting': PropTypes.func
};
export const sourcesType = PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  src: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  defaultSelected: PropTypes.bool
})])).isRequired;
export const tracksType = PropTypes.arrayOf(PropTypes.shape({
  id: PropTypes.string,
  src: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired
}));
export default {
  playerEventsTypeSet,
  rendererEventsTypeSet,
  sourcesType,
  tracksType
};